import { useState, useEffect } from 'react';
import config from './config';
import slugify from 'react-slugify';

export const useEventIds = () => {
    const [eventIds, setEventIds] = useState({
        // Evento actual
        currentEventID: null,
        currentEventID_en: null,
        currentEventID_pt_br: null,
        // Evento pasado
        pastEventID: null,
        pastEventID_en: null,
        pastEventID_pt_br: null,
        isLoading: true,
        error: null
    });

    const pastEventSlug = slugify(config.REACT_APP_PAST_EVENT_SLUG)
 
    useEffect(() => {
        const fetchEventIds = async () => {
            try {
                const languages = ['es', 'en', 'pt-br'];
                
                // Fetch para evento actual
                const currentPromises = languages.map(lang => 
                    fetch(`${config.REACT_APP_API_URL}/our_events?slug=${config.REACT_APP_EVENT_SLUG}&lang=${lang}`)
                        .then(res => res.json())
                );

                // Fetch para evento pasado
                const pastPromises = languages.map(lang => 
                    fetch(`${config.REACT_APP_API_URL}/our_events?slug=${pastEventSlug}&lang=${lang}`)
                        .then(res => res.json())
                );

                // Ejecutar todas las promesas
                const [currentResults, pastResults] = await Promise.all([
                    Promise.all(currentPromises),
                    Promise.all(pastPromises)
                ]);
                
                const ids = {
                    // IDs evento actual
                    currentEventID: currentResults[0][0]?.id,
                    currentEventID_en: currentResults[1][0]?.id,
                    currentEventID_pt_br: currentResults[2][0]?.id,
                    // IDs evento pasado
                    pastEventID: pastResults[0][0]?.id,
                    pastEventID_en: pastResults[1][0]?.id,
                    pastEventID_pt_br: pastResults[2][0]?.id,
                    isLoading: false,
                    error: null
                };

                setEventIds(ids);
            } catch (error) {
                setEventIds(prev => ({
                    ...prev,
                    isLoading: false,
                    error: 'Error fetching event IDs'
                }));
                console.error('Error fetching event IDs:', error);
            }
        };

        fetchEventIds();
    }, [pastEventSlug]);

    return eventIds;
};